import {h, Fragment} from "preact"
export default function Checkbox({ value, selected, onChange, className = "" }) {
    return (
        <label className={`flex items-center cursor-pointer ${className}`}>
            <input
                type="checkbox"
                checked={selected}
                onChange={onChange}
                className="hidden peer"
            />
            <span className="text-13-120 text-black-55 peer-checked:text-13-120-600 peer-checked:text-black">
                {value}
            </span>
        </label>
    )
}
